import { createContext, useState } from "react";
import Loading from "./Loading";
import Header from "./Header";
import Footer from "./Footer";

export const DataContext = createContext();

function AppLayout({ children = <></> }) {
  const [isVariant, setVariant] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isLoading, setLoading] = useState(true);

  return (
    <DataContext.Provider value={{ setVariant, setActiveIndex, setLoading }}>
      <Header activeIndex={activeIndex} isVariant={isVariant} />
      {isLoading && <Loading />}
      <MiddleData data={children} />
      <Footer />
    </DataContext.Provider>
  );
}


function MiddleData({ data }) {
  return data;
}

export default AppLayout;
